import { platformType, subscriptionPlanType } from './subscription.const'

export const KeyName = {
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  Backspace: 'Backspace',
  Enter: 'Enter',
  Escape: 'Escape',
  MediaPlay: 'MediaPlay',
  MediaPause: 'MediaPause',
  MediaPlayPause: 'MediaPlayPause',
}

export const KeyCode = {
  TizenBackKey: 10009,
  WebosBackKey: 461,
  Enter: 13,
  MediaPlayKey: 415,
  MediaPauseKey: 19,
  MediaPlayPauseKey: 10252,
}

export const CardTypes = {
  HORIZONTAL_CATEGORY: 'vel:cardtype:hcat',
  HORIZONTAL_SIMPLE: 'vel:cardtype:hs',
  HORIZONTAL_CONTINUE_WATCHING: 'vel:cardtype:hcw',
  HORIZONTAL_COMPLICATED: 'vel:cardtype:hc',
  HORIZONTAL_COMPLICATED_DATE: 'vel:cardtype:hcd',
  VERTICAL_SIMPLE: 'vel:cardtype:vs',
  HORIZONTAL_SIMPLE_POSTER_CAROUSEL: 'vel:displaytype:simplemoviecard', //:hspc
  SEARCH: 'searchRow', // :ht (horizontal title card)
  MY_LIST: 'myList', // :ht (horizontal title card)
  EPISODES: 'episode', // :ec (episode card)
}

export const PageTemplates = {
  FEED: 'vel:pagetype:feed',
  LOGIN: 'vel:pagetype:login',
  DETAILS: 'vel:pagetype:moviedetail',
}

export const Language = {
  EN: 'en',
  ES: 'es',
}

export const Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const ButtonIcon = {
  TICK: 'TICK',
  PLAY: 'PLAY',
  PLUS: 'PLUS',
  INFO: 'INFO',
}

export type ScrollBehavior = 'auto' | 'smooth'

export const splidesPerMove = 1
export const carouselHeroRailInterval = 5000

export type Direction = 'left' | 'right'

export const noResultsQueryParams = {
  platform: platformType.CTV,
  product: subscriptionPlanType.FREE,
  q: '',
  page: 0,
  perpage: '9',
}

export const ImageOverrides = {
  format: 't_IMG_FORMAT',
  extension: 'IMG_EXT',
}

export const ErrorCodes = {
  FETCH_CONFIG: '1',
  FETCH_VOCABULARY: '2',
  FETCH_MENU_ITEMS: '3',
  FETCH_FEED: '6',
  FETCH_DETAIL_PAGE: '8',
  FETCH_CATEGORY_PAGE: '9',
  FETCH_ENTITLEMENT: '10',
  FETCH_USER_COUNTRY: '11',
}

export const ErrorActions = {
  CONFIG: 'config',
  VOCABULARY: 'vocabulary',
  MENU: 'menu',
  FEED: 'feed',
  DETAILS: 'details',
  CATEGORY: 'category',
  ENTITLEMENT: 'entitlement',
  USER_COUNTRY: 'userCountry',
  CREATE_PROFILE: 'create-profile',
  DELETE_PROFILE: 'delete-profile',
}

export const exitAppErrorActions = [ErrorActions.MENU, ErrorActions.CONFIG, ErrorActions.VOCABULARY, ErrorActions.FEED]

export const fallbackThemeValues = [
  { name: '--textColor', value: '#ffffff' },
  { name: '--textColor-rgb', value: '255, 255, 255' },
  { name: '--primary', value: '#0A0132' },
  { name: '--primary-rgb', value: '22, 30, 42' },
  { name: '--secondary', value: '#281D56' },
  { name: '--secondary-rgb', value: '25, 36, 51' },
  { name: '--neutral', value: '#ffffff' },
  { name: '--neutral-rgb', value: '255, 255, 255' },
  { name: '--success', value: '#10AF46' },
  { name: '--success-rgb', value: '16, 175, 70' },
  { name: '--warning', value: '#F09814' },
  { name: '--warning-rgb', value: '240, 152, 20' },
  { name: '--danger', value: '#F94444' },
  { name: '--danger-rgb', value: '249, 68, 68' },
  { name: '--info', value: '#418DFF' },
  { name: '--info-rgb', value: '65, 141, 255' },
  { name: '--background', value: 'linear-gradient(#101720, #1b2533)' },
  { name: '--bgGradientTo', value: '#1b2533' },
]

export const errorScreenSpinnerTimeout = 200
export const PageTemplateType = {
  simpleHero: 'vel:displaytype:simplehero',
  rail: 'vel:displaytype:rail',
  carouselFullWidth: 'vel:displaytype:carouselhero',
}

export const RowTypes = {
  VERTICAL: 'verticalRow',
  HORIZONTAL: 'horizontalRow',
  SEARCH: 'searchRow',
  MYLIST: 'myList',
  EPISODES: 'episode',
}

export const Notification = {
  LOGOUT_USER: 'LOGOUT_USER',
}

export const RowSpeed = {
  HERO: 800,
  RAIL: 1000,
}

export const homeIcon = 'home'

export const LocalStorageItem = {
  ACTIVE_PROFILE: 'active_profile',
  USER_DATA: 'user_data',
  INITIAL_ROUTE: 'initial_route',
}

export const SessionStorageItem = {
  LAST_FOCUSED_ITEM_HOME: 'lastFocusedCard-home',
  LAST_FOCUSED_ITEM_MY_LIST: 'lastFocusedCard-myList',
  LAST_FOCUSED_ITEM_CATEGORY: 'lastFocusedCard-category',
}
